import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import UserFormSkeleton from '../../../../skeleton/UserFormSkeleton';
import Module from '../../../../layout/Module';
import Typography from '@mui/material/Typography';
import AlertSaveButton from '../../../../button/AlertSaveButton';
import ButtonStartIcon from '../../../../button/ButtonStartIcon';
import { useDispatch, useSelector } from 'react-redux';
import useUsers from '../../../../../hooks/users/useUsers';
import { Alert } from '@mui/material';
import Dialog from '../../../../dialog/Dialog';
import { toggleAlertModule } from '../../../../../store/actions/alert.actions';

const CreateUser = () => {
  const permission = useSelector(state => state.session?.permissions?.user || {})
  const formData = useSelector(state => state.user?.form || {})
  const alertSave = useSelector(state => state?.alert?.save || {})
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const [form, setInputForm] = useState({});
  const [errors, setInputErrors] = useState({})
  const [loading, toggleLoading] = useState(false)
  const [show, setShow] = useState(false)
  const { createUser } = useUsers()

  const onChange = (name, value) => {
    if (name === 'flag') {
      setInputForm({ ...form, data: { ...form.data, flag: value } })
    } else {
      setInputForm({ ...form, [name]: value })
      setInputErrors({ ...errors, [name]: '' })
    }
    if (!alertSave.mode || !alertSave.onSave) {
      dispatch(toggleAlertModule(false, 'Users', 'create', onSubmit, alertSave.onDontSave))
    }
  }

  useEffect(() => {
    setInputForm(formData || {})
    if (!formData.roles || formData.roles.length === 0) {
      onCancel()
      dispatch(toggleAlertModule(false, 'Users'))
    }
  }, [formData])
  
  const onCancel = () => {
    navigate(`/dashboard/users`)
  }

  const onSubmit = async () => {
    toggleLoading(true)
    setInputErrors({})
    try {
      let result = await createUser(form)
      if (result.error) {
        setInputErrors(result)
        return
      }
      onCancel()
    } finally {
      toggleLoading(false)
    }
  }

  return (
    <>
      <Module.BodyHeader className='border-b border-b-2 border-primary justify-between'>
        <Typography variant='subtitle1' className='text-primary'>
          Create user
        </Typography>
        <div className='flex items-center justify-end gap-2'>
          <AlertSaveButton
            submodule='Users'
            icon={['fal', 'times']}
            title='Cancel'
            color='primary'
            variant='outlined'
            className='shadow-sm'
            onDontSave={() => navigate(`/dashboard/users`)}
          />
          { permission.created &&
            <ButtonStartIcon
              disabled={loading}
              loading={loading}
              onClick={onSubmit}
              startIcon={['fal','check']}
              color='primary'
            >
              Save
            </ButtonStartIcon>
          }
        </div>
      </Module.BodyHeader>
      <Module.BodyContainer classNameWrapper='overflow-auto'>
        { errors && errors.message && 
          <Alert 
            severity="error"
            className='mb-4'
            onClose={() => setInputErrors({ message: null })}
          >
            {errors.message}
          </Alert> 
        }
        <UserFormSkeleton
          isLoadingForm={loading}
          form={form}
          isPreview={false}
          onChange={onChange}
          errors={errors}
          permission={['code', 'email']}
        />
      </Module.BodyContainer>
      <Dialog
        id={`user-preview-create`}
        show={show} 
        title="user preview"
        onClose={() => setShow(false)}
        onCloseHeader={true}
        maxWidth='md'
      >
        <UserFormSkeleton
          isLoading={loading}
          form={form}
        /> 
      </Dialog>
    </>
  )
}

export default CreateUser